'use strict';

var reduce = require('../iterable/reduce');

module.exports = function () {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (input) {
    return reduce(fns, function (value, fn) {
      return fn(value);
    }, input);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/thread.js
// module id = 2178
// module chunks = 37